import { render, staticRenderFns } from "./user-convention-role.vue?vue&type=template&id=c782ac0a&"
import script from "./user-convention-role.vue?vue&type=script&lang=js&"
export * from "./user-convention-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c782ac0a')) {
      api.createRecord('c782ac0a', component.options)
    } else {
      api.reload('c782ac0a', component.options)
    }
    module.hot.accept("./user-convention-role.vue?vue&type=template&id=c782ac0a&", function () {
      api.rerender('c782ac0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/administration/user-convention-role.vue"
export default component.exports